{
  "SEARCH": {
    "TABS": {
      "ALL": "Allt",
      "CONTACTS": "Tengiliðir",
      "CONVERSATIONS": "Samtöl",
      "MESSAGES": "Skilaboð"
    },
    "SECTION": {
      "CONTACTS": "Tengiliðir",
      "CONVERSATIONS": "Samtöl",
      "MESSAGES": "Skilaboð"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Search messages, contacts or conversations",
    "RECENT_MESSAGES": "Nýlega send skilaboð mín",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results.",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "frá",
    "EMAIL": "tölvupóstfang",
    "EMAIL_SUBJECT": "viðfangsefni"
  }
}
